import './select'

export default [
    {
        path: '/certificates',
        component: () => import('./index.vue'),
        children: [
            {
                path: 'add',
                component: () => import('./item/index.vue'),
            },
            {
                path: 'edit/:id',
                component: () => import('./item/index.vue'),
                props: true,
            },
        ]
    },
    {
        path: '/certificates/:path',
        component: () => import('./index.vue'),
        props: true,
    },
]